<template>
  <v-row no-gutters class="fill-height">
    <crud-table
      :service="service"
      :customFunctions="customFunctions"
      :crudDialog="crudDialog"
      :editCustomView="editCustomView"
    />
  </v-row>
</template>

<script>
import ServiceFactory from "@/services/ServiceFactory"

export default {
  components: {
    crudTable: () => import("@/components/crud_ag/Index.vue"),
  },
  props: {
    serviceName: {
      type: String,
      required: true,
    },
    customFunctions: {
      type: Object,
      required: false,
    },
    crudDialog: {
      type: Object,
      required: false,
    },
    editCustomView: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      service: ServiceFactory.get(this.serviceName),
    }
  },
}
</script>

<style lang="scss" scoped />
